module.exports = __webpack_public_path__ + "img/images_homebanner_2_2.677be75b.png";